import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex, Text, Box, ListItem, List, Heading } from '@qga/roo-ui/components';

export const NakedListItem = styled(ListItem)`
  list-style-type: none;
`;

const RoomFacilities = ({ facilities }) => (
  <Box p={5}>
    <Heading.h5 fontSize="md" color="greys.charcoal" mb={1} data-testid="facilities-title">
      Room facilities
    </Heading.h5>
    <Flex
      as={List}
      m={0}
      p={0}
      flexDirection={['column', 'row']}
      flexWrap="wrap"
      justifyContent="space-between"
      data-testid="facilities-list"
    >
      {facilities.map((facility) => (
        <Box
          as={NakedListItem}
          key={facility}
          py={3}
          m={0}
          borderBottom={1}
          borderColor="greys.alto"
          width={['100%', '45%']}
          data-testid="facility"
        >
          <Text fontSize="base" color="greys.steel">
            {facility}
          </Text>
        </Box>
      ))}
    </Flex>
  </Box>
);

RoomFacilities.propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.string),
};

RoomFacilities.defaultProps = {
  facilities: [],
};

export default RoomFacilities;
